import { useMediaQuery } from 'usehooks-ts'
import { SansText } from '../SansText/SansText'
import { TitleComposition } from '../TitleComposition/TitleComposition'
import { Composition } from './ParagraphComposition.styles'
import type { ParagraphCompositionProps } from './ParagraphComposition.types'

export const ParagraphComposition = ({
  upperTitle,
  title,
  paragraph,
}: ParagraphCompositionProps): JSX.Element => {
  const isMinWidth768px = useMediaQuery('(min-width: 768px)')

  return (
    <Composition>
      <TitleComposition upperTitle={upperTitle} title={title} />
      <SansText
        as="div"
        fontWeight="400"
        size={isMinWidth768px ? 'lg' : 'md'}
        color="dark"
        dangerouslySetInnerHTML={{ __html: paragraph }}
      />
    </Composition>
  )
}
